<template>
    <div>
        <h1 v-if="this.$route.params.id">Client &auml;ndern</h1>
        <h1 v-else>Neuen Client hinzuf&uuml;gen</h1>
        <table>
            <tr v-if="this.$route.params.id" class="plainTable" style="height: 40px">
                <td style="width: 240px">
                    <label for="apoId">ApoId:</label>
                </td>
                <td style="width: 300px">
                    <label type="text" style="padding: 10px">{{ this.client.id }}</label>
                </td>
            </tr>
            <tr class="plainTable" style="height: 40px">
                <td style="width: 240px">
                    <label for="customerId">{{ transl["STR_CUSTID"] }}:</label>
                </td>
                <td style="width: 300px">
                    <label v-if="this.$route.params.id" type="text" style="padding: 10px">{{ this.customerId }}</label>  
                    <input v-else v-model="customerId" type="text" maxlength="16" ref="cusId" autofocus />  
                </td>
            </tr>
            <tr class="plainTable">
                <td>
                    <label for="name">{{ transl["STR_NAME"] }}:</label>
                </td>
                <td>
                    <input v-model="name" type="text" maxlength="64" style="width: 500px"/>
                </td>
            </tr>
            <tr class="plainTable">
                <td>
                    <label for="email">{{ transl["STR_EMAIL"] }}:</label>
                </td>
                <td>
                    <input v-model="email" type="email" maxlength="128" style="width: 500px"/>
                </td>
            </tr>
            <tr class="plainTable">
                <td>
                    <label for="contact">{{ transl["STR_CONTACT"] }}:</label>
                </td>
                <td>
                    <input v-model="contact" type="text" maxlength="128" style="width: 500px"/>
                </td>
            </tr>
            <tr class="plainTable">
                <td>
                    <label for="phone1">{{ transl["STR_PHONE"] }} 1:</label>
                </td>
                <td>
                    <input v-model="phone1" type="text" maxlength="32" style="width: 250px"/>
                </td>
            </tr>
            <tr class="plainTable">
                <td>
                    <label for="phone2">{{ transl["STR_PHONE"] }} 2:</label>
                </td>
                <td>
                    <input v-model="phone2" type="text" maxlength="32" style="width: 250px"/>
                </td>
            </tr>
            <tr class="plainTable">
                <td>
                    <label for="zip">{{ transl["STR_POSTCODE"] }}:</label>
                </td>
                <td>
                    <input v-model="zip" type="text" maxlength="5" style="width: 80px"/>
                </td>
            </tr>
            <tr class="plainTable">
                <td>
                    <div v-if="this.$route.params.id" class="magic-button" v-on:click="submit()" style="float:left">&Auml;ndern</div>
                    <div v-else class="magic-button" type="submit" v-on:click="submit()" style="float:left">Hinzuf&uuml;gen</div>
                </td>
                <!-- td>
                    <div class="magic-button" type="submit" style="float:right" v-on:click="abort()">Abbrechen</div>
                </td -->
            </tr>
        </table>
        <div class="error" v-if="errors.length">
            <b>Bitte folgende Fehler korrigieren:</b>
            <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default ({
    props: [ 'transl' ],
    mounted() {
        if (this.$route.params.id) {
            this.client = this.$store.getters.getClients.find(e => e.id == this.$route.params.id);
            this.customerId = this.client.apoCustomerId;
            this.name = this.client.name;
            this.email = this.client.apoEmail;
            this.contact = this.client.apoContactPerson;
            this.phone1 = this.client.apoPhone1;
            this.phone2 = this.client.apoPhone2;
            this.zip = this.client.apoPLZ;
        } else {
            this.$refs.cusId.focus();
        }
    },
    data() {
        return {
            customerId: "",
            name: "",
            email: "",
            contact: "",
            phone1: "",
            phone2: "",
            zip: "",
            client: null, 
            errors:[]
        }
    },
    methods: {
        submit() {
            this.checkForm();
            if (this.errors.length === 0) {
                if (this.$route.params.id) {
                    this.updateClient();
                } else {
                    this.addClient();
                }
            }
                
        },
        checkForm() {
            this.errors = [];
            if (this.customerId === null || this.customerId === '') {
                this.errors.push("Kundennummer fehlt");
            }

            if(this.name === null || this.name === '') {
                this.errors.push("Name fehlt");
            }

            if(this.email === null || this.email === '') {
                this.errors.push("E-Mail Adresse fehlt");
            } else if (!this.validEmail(this.email)) {
                this.errors.push("E-Mail Adresse ist ungültig");
            }

            if(this.contact == null || this.contact === '') {
                this.errors.push("Kontaktperson fehlt");
            }

            if (this.phone1 !== null && this.phone1 !== '') {
                if (this.phone1.length < 5) {
                    this.errors.push("Tel Nummer 1 ist zu kurz");
                } else if (!this.validPhone(this.phone1)) {
                    this.errors.push("Tel Nummer 1 ist ungültig");
                }
            }

            if (this.phone2 !== null && this.phone2 !== '') {
                if (this.phone2.length < 5) {
                    this.errors.push("Tel Nummer 2 ist zu kurz");
                } else if (!this.validPhone(this.phone2)) {
                    this.errors.push("Tel Nummer 2 ist ungültig");
                }
            }

            if(this.zip === null || this.zip === '') {
                this.errors.push("PLZ fehlt");
            } else if (this.zip.length < 4) {
                this.errors.push("PLZ ist zu kurz");
            } else if (!this.validZip(this.zip)) {
                this.errors.push("PLZ ist ungültig");
            }
        },
        addClient() {
            let data = {
                apoCustomerId: this.customerId.trim(),
                apoName: this.name.trim(),
                apoEmail: this.email.trim(),
                apoContactPerson: this.contact.trim(),
                apoPLZ: this.zip,
            }

            if (this.phone1 !== '') {
                data["apoPhone1"] = this.phone1;
            }

            if (this.phone2 !== "") {
                data["apoPhone2"] = this.phone2;
            }

            this.$store.dispatch("AddUserClient", data)
            .then(() => {
                //update data store
                this.$store.dispatch("FetchUserClients");
                this.$router.push({
                    name: 'ShowClients'
                })
            })
            .catch((e) => {
                this.errors.push("Das Hinzufügen einer Aphotheke hat leider nicht funktioniert!");
                console.log(e);
            })
        },
        updateClient() {
            let data = {}

            if (this.customerId !== this.client.customerId) {
                data["apoCustomerId"] = this.name.trim();
            }

            if (this.name !== this.client.name) {
                data["apoName"] = this.name.trim();
            }
            
            if (this.email !== this.client.apoEmail) {
                data["apoEmail"] = this.email.trim();
            }

            if (this.contact !== this.client.apoContactPerson) {
                data["apoContactPerson"] = this.contact.trim();
            }

            if (this.phone2 !== this.client.apoPhone2) {
                data["apoPhone2"] = this.phone2;
            }

            if (this.phone1 !== this.client.apoPhone1) {
                data["apoPhone1"] = this.phone1;
            }

            if (this.zip !== this.client.apoPLZ) {
                data["apoPLZ"] = this.zip;
            }

            if (Object.keys(data).length === 0) {

                this.errors.push("Es wurden keine Daten geändert!");
                return
            }

            this.$store.dispatch("UpdateUserClient", {id: this.$route.params.id, data})
            .then(() => {
                //update data store
                this.$store.commit("updateClient", {id: this.$route.params.id, data});
                this.$router.push({
                    name: 'ShowClients'
                })
            })
            .catch((e) => {
                this.errors.push("Das Ändern der Aphotheke hat leider nicht funktioniert!");
                console.log(e);
            })
        },
        abort(){
            this.$router.push({
                name: 'ShowClients'
            })
        },
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validPhone(number) {
            const re = /^\d+$/;
            return re.test(number);
        },
        validZip(number) {
            const re = /^\d+$/;
            return re.test(number);
        }
    }
})
</script>
